import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"height":"450px"} }

import gridBase from '@/components/ui/grid/grid-base.vue';
import { DxColumn } from "devextreme-vue/data-grid";
import { AppointmentStatuses } from '@/enums/appointments/AppointmentStatuses';
import { ContactPropertyApiAppointmentFilters } from '@/types/diary/ContactPropertyApiAppointmentFilters';
import EditAppointmentModal from '@/components/ui/diary/edit-appointment-modal.vue';
import { AcquaintApiClient } from '@/services/AcquaintApiClient';
import { AppointmentWithProperty } from '@/types/diary/AppointmentWithProperty';
import { computed, onMounted, ref, inject } from 'vue';
import { AcquaintApiNextClient } from '@/services/AcquaintApiNextClient';
import displayErrorMessage from '@/utils/ErrorHandling';
import { getErrorMessage } from 'bright-logic-core/src/errors';
import { useCurrentUserStore } from '@/stores/CurrentUserStore';
import { CurrentUser } from '@/types/user/CurrentUser';


export default /*#__PURE__*/_defineComponent({
  __name: 'appointments-card',
  setup(__props) {

const apiNextClient = inject('AcquaintApiNextClient') as AcquaintApiNextClient;
const acquaintApiClient = inject('AcquaintApiClient') as AcquaintApiClient;
const loadingAppointmentData = ref(false);
const appointments = ref<AppointmentWithProperty[]>([]);
const selectedAppointmentRecord = ref<AppointmentWithProperty>();
const displayEditAppointmentModal = ref(false);
const currentUserStore = useCurrentUserStore();
const currentUser = ref<CurrentUser>();

onMounted(async ()=>{
    currentUser.value = await currentUserStore.getCurrentUserDetails();
    fetchMapAppointments();
});


// Fetch appointments
const fetchAppointments = async () => {
  loadingAppointmentData.value = true;

  try {
    appointments.value = await apiNextClient.httpPost(`appointments/list`, appointmentFilters.value)
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    appointments.value = [];
  }

  loadingAppointmentData.value = false;
};

const fetchMapAppointments = async () => {
  await fetchAppointments();

  if (appointments.value.length > 0) {
    appointments.value = appointments.value.map((appointment) => {
      return { ...appointment, include: false };
    });
  }
};

const customStartDateText = (e: any) => e.valueText;


const appointmentFilters = computed(() => {
  const filters = new ContactPropertyApiAppointmentFilters();

  filters.status = AppointmentStatuses.Future14Days;
  filters.assignedTo = [currentUser.value?.id ?? -1];

  return filters;
});


// Edit appointment records
const appointmentDoubleClick = async (e: any) => {
  if (!e) {
      return;
  }

  selectedAppointmentRecord.value = e;

  if (!await lockAppointments()) {
    return;
  }

  displayEditAppointmentModal.value = true;
};

const editModalClosed = (appointmentUpdated: boolean, id:number) => {
  unLockAppointments(id);

  fetchAppointments();
};

// Locking code
const lockAppointments = async () => {
  try {
    await acquaintApiClient.httpPostVoid(`database/appointments/${selectedAppointmentRecord.value?.id}/lock`, {
      lock: true,
      extraInfo: ''
    });
    return true;
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    return false;
  }
};

const unLockAppointments = async (id: number) => {
  try {
    await acquaintApiClient.httpPostVoid(`database/appointments/${id}/lock`, {
      lock: false,
      extraInfo: ''
    });
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
  }
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(gridBase, {
        "data-source": appointments.value,
        "id-column-name": "id",
        loading: loadingAppointmentData.value,
        "show-action-button": true,
        "custom-column-slots": ['includeCell'],
        wordWrapEnabled: true,
        onRowClick: _cache[0] || (_cache[0] = (e) => appointmentDoubleClick(e))
      }, {
        columns: _withCtx(() => [
          _createVNode(_unref(DxColumn), {
            "data-field": "startDate",
            caption: "Start Date",
            "hiding-priority": 11,
            "data-type": "date",
            format: "dd/MM/yyyy HH:mm",
            width: "120px",
            "customize-text": customStartDateText
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "duration",
            caption: "Duration",
            "hiding-priority": 9,
            width: "150px"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "description",
            caption: "Description",
            "hiding-priority": 10,
            width: "180px"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "property",
            caption: "Property",
            "hiding-priority": 8,
            width: "200px"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "confirmed",
            caption: "Confirmed",
            "hiding-priority": 7,
            width: "90px"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "applicantFollowedUp",
            caption: "Applicant Followed Up",
            "hiding-priority": 6,
            width: "155px"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "ownerFollowedUp",
            caption: "Owner Followed Up",
            "hiding-priority": 5,
            width: "140px"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "noShow",
            caption: "No Show",
            "hiding-priority": 4,
            width: "75px"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "cancelled",
            caption: "Cancelled",
            "hiding-priority": 3,
            width: "100px"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "attendees",
            caption: "Attendees",
            "hiding-priority": 2
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "assignedUser",
            caption: "Assigned User",
            "hiding-priority": 1,
            width: "175px"
          })
        ]),
        _: 1
      }, 8, ["data-source", "loading"])
    ]),
    (selectedAppointmentRecord.value)
      ? (_openBlock(), _createBlock(EditAppointmentModal, {
          key: 0,
          modelValue: displayEditAppointmentModal.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((displayEditAppointmentModal).value = $event)),
          appointmentId: selectedAppointmentRecord.value?.id,
          onModalClosed: editModalClosed
        }, null, 8, ["modelValue", "appointmentId"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})